import React from 'react';
import SentenceForm from "../../components/common/SentenceForm";
import Container from "@material-ui/core/Container";
import TextField from "@material-ui/core/TextField";
import ScrollableAnchor from "react-scrollable-anchor";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {answerState, menuCheckSelector, selectedMenuItemState, surveyDataState} from "../../state/globalState";

/**
 * 설문 문항 컴포넌트 (사원번호)
 */
const Survey5 = (props) => {
    const surveyData = useRecoilValue(surveyDataState);
    const [answer, setAnswer] = useRecoilState(answerState);
    const setSelectedMenuItem = useSetRecoilState(selectedMenuItemState);
    const setMenuCheck = useSetRecoilState(menuCheckSelector);
    const userNo = answer.empNo;
    let parentCompRef = props.compRef;

    const handleInputAnswer = (e, column) => {
        const { value } = e.target;

        if (value.length < 20) {
            const newState = {
                ...answer,
                [column]: value
            }
            setAnswer(newState);

            setSelectedMenuItem('SURVEY_12');
            setMenuCheck(value !== '');
        }
    };

    const addRefs = (e) => {
        parentCompRef[12] = e;
    };

    return (
        <>
            <ScrollableAnchor id={"12"}>
                <div>
                <Container style={{background: 'transparent', marginBottom: '10px'}}>
                    <SentenceForm
                        title={surveyData[12].title}
                        sentences={surveyData[12].questions}
                        step={12}
                    />
                    <div className="textFieldContainer">
                        <TextField
                            label="여기에 답변을 입력하십시오."
                            placeholder=""
                            margin="none"
                            value={userNo}
                            onChange={(e) => handleInputAnswer(e, 'empNo')}
                            inputRef={addRefs}
                        />
                    </div>
                </Container>
                </div>
            </ScrollableAnchor>
        </>
    );
};

export default Survey5;
